namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class CityLookupEditor extends Serenity.Select2AjaxEditor<CityLookupEditorOptions, Master.CitiesRow> {
        

        public _lastRequest: JQueryXHR;
        public option: CityLookupEditorOptions;
        private _stateID: number;

        constructor(hidden: JQuery, opt: CityLookupEditorOptions) {
            super(hidden, opt);
            this.option = opt;
            this.BindToSiteEditor();
        }

        public destroy(): void {
            this.UnbindFromSiteEditor();
            super.destroy();
        }

        public getService(): string {
            return "Master/Cities";
        }

        public getItemKey(item: Master.CitiesRow): string {
            return item.Id.toString();
        }

        public getItemText(item: Master.CitiesRow): string {
            return item.Name;
        }

        public getTypeDelay(): number {
            return 500;
        }

        public executeQueryByKey(options: Serenity.ServiceOptions<Serenity.RetrieveResponse<Master.CitiesRow>>): void {
            var request = <Serenity.RetrieveRequest>options.request;
            request.ColumnSelection = Serenity.RetrieveColumnSelection.keyOnly;
            request.IncludeColumns = this.GetIncludeColumns();
            super.executeQueryByKey(options);
        }

        public GetIncludeColumns(): string[] {
            return [Master.CitiesRow.Fields.Name];
        }

        public executeQuery(options: Serenity.ServiceOptions<Serenity.ListResponse<Master.CitiesRow>>): void {
            var request = <Serenity.ListRequest>options.request;
            request.ColumnSelection = Serenity.ColumnSelection.KeyOnly;
            request.IncludeColumns = this.GetIncludeColumns();
            request.Sort = [Master.CitiesRow.Fields.Name];
            request.IncludeDeleted = true;
            request.ExcludeTotalCount = true;
            if (this.StateID != null) {
                if (request.EqualityFilter == null) {
                    request.EqualityFilter = {};
                }
                request.EqualityFilter[Master.CitiesRow.Fields.StateId] = this.StateID;
            }
            options.blockUI = false;
            options.error = () => {
            };

            if (this._lastRequest != null && this._lastRequest.readyState != XMLHttpRequest.DONE)
                this._lastRequest.abort();

            this._lastRequest = Q.serviceCall(options);
            var self = this;
            this._lastRequest.then(() => self._lastRequest = null, () => self._lastRequest = null);
        }

        private BindToSiteEditor(): void {
            if (this.StateEditor == null || this.StateEditor == "")
                return;

            var editor = Q.findElementWithRelativeId(this.element, this.StateEditor).tryGetWidget(StateLookupEditor);
            if (editor != null) {
                var self = this;
                editor.element.bind("change." + this.uniqueName, () => {
                    this.StateID = Number(editor.value);
                });
            }
        }

        private UnbindFromSiteEditor(): void {
            if (this.StateEditor == null || this.StateEditor == "")
                return;
            var editor = Q.findElementWithRelativeId(this.element, this.StateEditor).tryGetWidget(StateLookupEditor);
            if (editor != null)
                editor.element.unbind("." + this.uniqueName);
        }

        public get StateEditor(): string {
            return this.option.StateEditor;
        }

        public set StateEditor(val) {
            if (this.StateEditor != val) {
                this.UnbindFromSiteEditor();
                this.option.StateEditor = val;
                this.BindToSiteEditor();
            }
        }

        public get StateID(): number {
            return this._stateID;
        }

        public set StateID(val) {
            if (this._stateID != val) {
                this._stateID = val;
                this.value = null;
            }
        }

    }
    export class CityLookupEditorOptions {
        StateEditor: string;
    }

}